import React from 'react'

export default function CheckBoxLeftIcon() {
    return (
        <svg width="11" height="9" viewBox="0 0 11 9" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="1.25312" height="5.03056" transform="matrix(0.687681 -0.726013 0.687681 0.726013 0 5.34778)" fill="black" />
            <rect width="1.23684" height="9.92455" transform="matrix(0.687681 0.726013 -0.687681 0.726013 9.4425 0.893921)" fill="black" />
        </svg>
    )
}

CheckBoxLeftIcon.displayName = 'CheckBoxLeftIcon';